import { Mixins, Component } from 'vue-property-decorator'
import gql from 'graphql-tag'

import { LanguagesMixin } from '@/@next/mixins'
import { PaginationOptions, SortArgs, CollectionList, Collection, Scalars, I18nTarget } from '@/@types/graphql'

import { MediaImageFragment } from './fragments'
import { LanguageCode, Nullable } from '../@types'

@Component({ name: 'collections-service' })
export default class Collections extends Mixins(LanguagesMixin) {

  async GET_ALL_COLLECTION_IDS (): Promise<Array<Scalars['UUID']>> {
    const query = gql`
        query collections {
            collections {
                items {
                    id
                }
            }
        }
    `
    const { data } = await this.$apollo.query({ query })
    return data?.collections.items.map((item: Collection) => item.id) || []
  }

    async GET_ALL_COLLECTIONS (
    pagination: PaginationOptions = {},
    sort: SortArgs = {},
    language: Nullable<LanguageCode> = null,
    languages: Nullable<LanguageCode[]> = null,
    target: Nullable<I18nTarget> = null
  ): Promise<CollectionList> {
    const variables = {
      pagination,
      sort,
      languages: languages || this._userLanguages,
      language: language || this._currentLanguage,
      target: target || this._languageTarget || null
    }
    const query = gql`

        ${ MediaImageFragment }

        query collections (
          $pagination: PaginationArgs,
          $sort: SortArgs
          $languages: [LanguageCode!]!,
          $language: LanguageCode!,
          $target: I18nTarget
          ) {
            collections (pagination: $pagination, sort: $sort, language: $language) {
                itemsCount
                totalCount
                pagination {
                    skip
                    take
                }
                sort {
                    field,
                    order
                }
                items {
                    id
                    languages
                    slug
                    shortCode
                    publishedAt
                    locks {
                      slug
                      data
                    }
                    i18n (languages: $languages, target: $target) {
                        title { value { text html } language  }
                        abstract { value { text html } language  }
                        description { value { text html } language  }
                    }
                    image { ...MediaImageFragment }
                  pointsOfInterest (language: $language) {
                    items {
                      id
                      image { ...MediaImageFragment }
                      i18n (languages: $languages, target: $target) {
                        title { value { text html } language  }
                      }
                      publishedAt
                    }
                  }
                }
            }
        }
    `
    const { data } = await this.$apollo.query({ query, variables })
    return data.collections
  }

  async GET_SINGLE_COLLECTION (
    id: Scalars['UUID'],
    pointsOfInterestPagination: PaginationOptions = {},
    language: Nullable<LanguageCode> = null,
    languages: Nullable<LanguageCode[]> = null,
    target: Nullable<I18nTarget> = null
  ): Promise<Collection> {
    const variables = {
      id,
      pointsOfInterestPagination,
      languages: languages || this._userLanguages,
      language: language || this._currentLanguage,
      target: target || this._languageTarget || null
    }
    console.log('Get Single collection', variables)
    const query = gql`

      ${ MediaImageFragment }

      query collection(
        $id: UUID!,
        $pointsOfInterestPagination: PaginationArgs,
        $languages: [LanguageCode!]!,
        $language: LanguageCode!,
        $target: I18nTarget
        ) {
          collection (id: $id) {
              id
              slug
              shortCode
              languages
              publishedAt
              name
              style
              i18n (languages: $languages, target: $target) {
                  title { value { text html } language  }
                  abstract { value { text html } language  }
                  description { value { text html } language  }
              }
              image { ...MediaImageFragment }
              placeholders {
                id
                layer {
                  id
                  name
                  i18n (languages: $languages, target: $target) {
                      title { value { text html } language  }
                      abstract { value { text html } language  }
                      description { value { text html } language  }
                  }
                }
                map {
                  id
                  name
                  i18n (languages: $languages, target: $target) {
                      title { value { text html } language  }
                      abstract { value { text html } language  }
                      description { value { text html } language  }
                  }
                }
              }
              locks {
                slug
                data
              }
              pointsOfInterest (pagination: $pointsOfInterestPagination, language: $language) {
                  itemsCount
                  totalCount
                  sort { field order}
                  items {
                      id
                      publishedAt
                      slug
                      shortCode
                      languages
                      style
                      audioGuideTracks {
                          id
                          shortCode
                          languages
                          i18n (languages: $languages, target: $target) {
                            audio { target }
                            video { target }
                        }
                      }
                      i18n (languages: $languages, target: $target) {
                          title { value { text html } language  }
                          abstract { value { text html } language  }
                          description { value { text html } language  }
                      }
                      image { ...MediaImageFragment }
                      people {
                        id
                        name { value { text html } language }
                        role {
                          id
                          slug
                          name { language value }
                        }
                        image { ...MediaImageFragment }
                        i18n (languages: $languages, target: $target) {
                          bio { value { text html } language }
                          bornAt { value { text html } language }
                          diedAt { value { text html } language }
                        }
                      }
                  }
              }
          }
      }
    `

    const { data } = await this.$apollo.query({ query, variables })
    return data.collection
  }
}
